/* Elyia — collection & search filtering and sorting without page reloads */
(() => {
  'use strict';
  const debounce = (fn, wait) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; };
  const cache = new Map();

  const render = async (sectionId, searchParams, pushState = true) => {
    const results = document.getElementById(`FacetsResults-${sectionId}`);
    if (results) results.classList.add('is-loading');
    const params = new URLSearchParams(searchParams);
    params.set('section_id', sectionId);
    const url = `${window.location.pathname}?${params.toString()}`;
    try {
      let html = cache.get(url);
      if (!html) {
        const res = await fetch(url);
        html = await res.text();
        cache.set(url, html);
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      [`FacetsResults-${sectionId}`].forEach((id) => {
        const fresh = doc.getElementById(id);
        const current = document.getElementById(id);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
      const freshFilters = doc.querySelector(`#FacetsDrawer-${sectionId} [data-facets-filters]`);
      const currentFilters = document.querySelector(`#FacetsDrawer-${sectionId} [data-facets-filters]`);
      if (freshFilters && currentFilters) {
        // Preserve open/closed state of each filter group
        const openState = Array.from(currentFilters.querySelectorAll('details')).map((d) => d.open);
        currentFilters.innerHTML = freshFilters.innerHTML;
        currentFilters.querySelectorAll('details').forEach((d, i) => { if (openState[i] !== undefined) d.open = openState[i]; });
      }
      const freshCount = doc.querySelector('[data-facets-count]');
      const currentCount = document.querySelector(`#shopify-section-${sectionId} [data-facets-count]`) || document.querySelector('[data-facets-count]');
      if (freshCount && currentCount) currentCount.textContent = freshCount.textContent;
      if (pushState) {
        const clean = new URLSearchParams(searchParams);
        clean.delete('section_id');
        const qs = clean.toString();
        window.history.pushState({ sectionId, qs }, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
      }
    } catch (e) {
      console.error(e);
      window.location.search = searchParams;
    } finally {
      const r = document.getElementById(`FacetsResults-${sectionId}`);
      if (r) r.classList.remove('is-loading');
    }
  };

  const formParams = (form) => {
    const data = new FormData(form);
    const select = document.querySelector(`select[form="${form.id}"]`);
    if (select && !data.has('sort_by')) data.set('sort_by', select.value);
    const params = new URLSearchParams();
    for (const [k, v] of data.entries()) { if (v !== '') params.append(k, v); }
    return params.toString();
  };

  const onChange = debounce((input) => {
    const formId = input.form ? input.form.id : input.getAttribute('form');
    const form = document.getElementById(formId);
    if (!form) return;
    render(form.dataset.sectionId, formParams(form));
  }, 400);

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-facets-input]')) onChange(e.target);
  });

  document.addEventListener('submit', (e) => {
    if (!e.target.matches('[data-facets-form]')) return;
    e.preventDefault();
    render(e.target.dataset.sectionId, formParams(e.target));
  });

  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facets-link], [data-facets-clear]');
    if (!link) return;
    const wrapper = link.closest('[data-facets-section]');
    if (!wrapper) return;
    e.preventDefault();
    const url = new URL(link.href, window.location.origin);
    render(wrapper.dataset.facetsSection, url.searchParams.toString());
    if (link.matches('[data-facets-link]') && link.closest('.pagination')) {
      wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  window.addEventListener('popstate', (e) => {
    const wrapper = document.querySelector('[data-facets-section]');
    if (!wrapper) return;
    render(wrapper.dataset.facetsSection, (e.state && e.state.qs) || window.location.search.slice(1), false);
  });
})();
